// Importing the Rellax library
import Rellax from 'rellax';

// Using the Rellax library to make all divs with a class of 'rellax' parallax

window.addEventListener('load', function () {
    const rellax = new Rellax('.ccm-image-block.rellax', {
        speed: 4,
        center: true
    });
});